import {MapContentLayer} from '../MapContentLayer';
import {MapContentSource} from '../MapContentSource';
import { FilterSpecification, LayerSpecification, LineLayerSpecification } from 'maplibre-gl';
import { RouteAssignment } from '../../../../models/route-assignment';
import { RouteConfigurationWithSchema, RouteHierarchyItemWithPath } from '../../../../models/route';
import { LineStyle } from '../../../../models/styling';

export class RouteLayer extends MapContentLayer {

  constructor(
    source: MapContentSource,
    private routeConfigurations: RouteConfigurationWithSchema[],
    private routes: RouteHierarchyItemWithPath[],
    private assignment?: RouteAssignment, // if null, nothing is displayed
  ) {
    super('route-layer', source);
  }

  toLayerSpecification(): LayerSpecification {
    let paint = {};
    if (this.assignment) {
      const routeConfiguration = this.routeConfigurations.find(rc => rc.id === this.assignment.configId);
      let globalRouteStyle = routeConfiguration?.schema?.style;
      if (!globalRouteStyle) {
        console.warn('Missing schema style. This should not happen!');
        globalRouteStyle = new LineStyle('#FF0000', 4, 1.0);
      }
      const route = this.routes.find(r => r.configId === this.assignment.configId && r.routeId === this.assignment.routeId);
      paint = {
        'line-color': !!route.styleOverride?.color ? route.styleOverride.color : globalRouteStyle.color,
        'line-width': [
          'interpolate',
          ['exponential', 2],
          ['zoom'],
          10, ['*', globalRouteStyle.width, ['^', 2, -1]],
          24, ['*', globalRouteStyle.width, ['^', 2, 8]]
        ],
        'line-opacity': globalRouteStyle.opacity,
        'line-dasharray': !!route.styleOverride?.lineType
          ? ['literal', route.styleOverride.lineType]
          : ['literal', !!globalRouteStyle.lineType ? globalRouteStyle.lineType : [10]],
      };
    }

    return {
      id: this.layerId,
      type: 'line',
      source: this.sourceRef.sourceId,
      filter: this.getRouteFilter(),
      layout: {
        'line-join': 'miter',
        'line-cap': 'butt',
        'line-miter-limit': 2,
      },
      paint,
    } as LineLayerSpecification;
  }

  private getRouteFilter(): FilterSpecification {
    if (!this.assignment) {
      return ['all', ['boolean', false]];
    } else {
      return [
        'all',
        ['==', ['get', 'routeid'], this.assignment.routeId],
        ['==', ['get', 'configid'], this.assignment.configId],
      ];
    }
  }
}
